import React from "react";
import Layout from "../layout";

const Disclaimer = () => {
  return (
    <>
      <div className="bg-light w-[80%] mx-auto py-20 min-h-screen">
        <h1 className="text-12xl max-sm:text-5xl font-lightBold text-dark">
          Disclaimer For Mixxer
        </h1>
        <p className=" text-lightbrown text-lg font-normal mb-4">
          If you have any questions about this disclaimer, feel free to reach us
          at{" "}
          <a
            href="mailto:contactus@mixxerco.com"
            className="text-blue-600 hover:underline"
          >
            contactus@mixxerco.com
          </a>{" "}
          .
        </p>
        <h1 className=" text-2xl font-medium text-dark">General Disclaimer</h1>
        <p className=" text-lightbrown text-lg font-normal mb-4">
          All the information on our website –{" "}
          <a
            href="https://www.mixxerco.com"
            className="text-blue-600 hover:underline"
          >
            www.mixxerco.com
          </a>{" "}
          – is published in good faith and for general information purposes
          only. Mixxer, LLC ("Mixxer") does not make any warranties about the
          completeness, reliability, or accuracy of this information. Any action
          you take based on the information found on this website is strictly at
          your own risk. Mixxer is not liable for any losses or damages in
          connection with the use of our platform.
        </p>
        <h1 className=" text-2xl font-medium text-dark">
          External Links and User-Submitted URLs
        </h1>

        <p className=" text-lightbrown text-lg font-normal mb-4">
          From our site or app, you may access third-party websites through
          user-submitted or externally shared links. While we take steps to
          screen links for safety using automated systems, no technology is
          perfect.
        </p>
        <h2 className=" text-2xl font-medium text-dark mb-1">
          Here’s what we do:
        </h2>

        <ul className="mb-3 text-lightbrown list-disc pl-5">
          <li>
            We check all submitted URLs against known safety risks using
            reputable detection tools.
          </li>
          <li>If a link appears unsafe, we block it from being submitted.</li>
          <li>
            We also allow users to report suspicious links for immediate review
            and disabling.
          </li>
        </ul>

        <h2 className=" text-2xl font-medium text-dark mb-1">
          But here’s what you should know:
        </h2>
        <ul className="mb-3 text-lightbrown list-disc pl-5">
          <li>These checks are helpful, but they’re not foolproof.</li>
          <li>
            A link may pass initial validation and still lead to content that’s
            misleading, unsafe, or changes over time.
          </li>
          <li>
            Mixxer is not responsible for harm caused by clicking or interacting
            with any external links.
          </li>
        </ul>
        <p className=" text-lightbrown text-lg font-normal mb-2">
          We strongly encourage all users to exercise good judgment. Before
          clicking any link, consider who posted it, what it’s promoting, and
          whether it looks trustworthy. If it seems off — don’t click.
        </p>
        <h2 className=" text-2xl font-medium text-dark mb-1">Consent</h2>
        <p className=" text-lightbrown text-lg font-normal mb-2">
          By using our site or app, you consent to this disclaimer and agree to
          its terms.
        </p>

        <h2 className=" text-2xl font-medium text-dark mb-1">Updates</h2>
        <p className=" text-lightbrown text-lg font-normal">
          We may update or amend this disclaimer. Any changes will be posted
          prominently here.
        </p>
      </div>
    </>
  );
};

export default Layout(Disclaimer);
